import { record, upper, type Row } from '../ability/context';
import { statusItemId } from '../statuses/expiry';
import { readItemField } from './item-field-reader';
import { recompileFormRemoval } from './form-revert';

/** NPC commands need their native body before support/overflow can run. Saved
 * observers use the ordinary result/recovery contract instead of this gate. */
export function npcFormRemovalPlanFailure(row: Row, status: Row, definition: (id: string) => Row | null): string | null {
    if (record(row.player_characters)) return null;
    const result = recompileFormRemoval(row, [{ kind: 'remove', statusId: upper(readItemField(status, 'status_id')),
        statusItemId: statusItemId(status) }], definition);
    return result && !result.ok ? result.reason : null;
}
